// extracted by mini-css-extract-plugin
export default {"container":"Status_container__44B3b","text":"Status_text__RKc0N"};